module.exports = __webpack_public_path__ + "img/c13.392fa83a.jpg";